import Vue from 'vue'
import store from "./store";
import App from './App.vue'
import router from './router'
import moment from 'moment'
//antd
import Antd from 'ant-design-vue'
import './theme.less'

//axios
import axios from "axios";

import api from './utils/api.js';

Vue.use(Antd);

Vue.config.productionTip = false

Vue.prototype.$http = axios;

Vue.prototype.$moment = moment;

// axios.defaults.baseURL = "http://test-jq-admin-api.jqdev.com"//test-jq-admin-api.jqdev.com
// axios.defaults.baseURL = "http://test-jq-admin-api.jqdev.com"
axios.defaults.baseURL = api.getUser;
axios.defaults.withCredentials = true

axios.interceptors.request.use(function (config) {
  let token = localStorage.getItem('Authorization')
  if (token) {
    config.headers['jqsoft-admin'] = token
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response && error.response.status === 401) {
    router.push({ path: '/login' })
  }
  return Promise.reject(error.response.data);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
